/**
 * API Endpoints
 * Centralized endpoint configuration for all auth flows.
 */

export const API_ENDPOINTS = {
    // -----------------------------------------------------------------------------------------------------------------------------------/
    // Signup flow
    SIGNUP_IDENTIFY: "/initial/step",
    SIGNUP_VERIFY_EMAIL_OTP: "/otp/validate",
    OWNERSHIP_OTP_VALIDATE: "/ownership/otp/validate",
    SIGNUP_PROFILE: "/submit/profile",
    SIGNUP_VERIFY_PHONE_OTP: "/phone/otp/validate",
    SIGNUP_RESEND_PHONE_OTP: "/phone/otp/resend",
    SIGNUP_SET_PASSWORD: "/set/password",

    // Signup MFA (Shared / Enrollment)
    TOTP_INIT: "/signup/totp/initial",
    TOTP_CONFIRM: "/signup/config/otp/validate",

    // unused - may be used in future
    WEBAUTHN_REGISTER_INIT: "/auth/webauthn/register-init", // Dummy URL
    WEBAUTHN_REGISTER_COMPLETE: "/auth/webauthn/register-complete", // Dummy URL

    // Signup MFA (Skip)
    SIGNUP_MFA_SKIP: "/signup/skip/mfa",

    // Signup Backup codes
    BACKUP_CODES_GENERATE: "/auth/backup-codes/generate", // URL not active
    BACKUP_CODES_CONFIRM: "/signup/final/complete",

    // Deletion
    SIGNUP_INITIAL_DELETE: "/signup/initial.delete",
    // -----------------------------------------------------------------------------------------------------------------------------------/

    // Signin flow

    // signin with username, password, captcha
    SIGNIN_PASSWORD: "/login/password/verification",
    SIGNIN_VERIFY_TOTP: "/login/otp/validate",
    SIGNIN_VERIFY_BACKUP_CODE: "/login/backup/code/validate",
    SIGNIN_FORCE_CHANGE_PASSWORD: "/login/force/password/change",
    SIGNIN_MFA_SETUP_INIT: "/login/totp/initial",
    SIGNIN_MFA_SETUP_CONFIRM: "/login/config/otp/validate",
    SIGNIN_CONFIRM_BACKUP_CODES: "/login/final/complete",
    // SIGNIN_REDIRECT: "/auth/login",
    SIGNIN_REDIRECT: "/login/user/redirect",
    SIGNIN_MFA_SKIP: "/login/skip/mfa",
    // OIDC Frontend-Initiated Callback: exchanges code for JSON { status, redirect_to }
    OIDC_CALLBACK: "/signin/callback",
    MOBILE_GET_ACCESS_TOKEN: "/login/user/redirect/access_token",

    // unused - may be used in future
    SIGNIN_MFA_METHODS: "/auth/mfa/methods",
    SIGNIN_GENERATE_BACKUP_CODES: "/auth/login/backup-codes/generate",
    SIGNIN_WEBAUTHN_ASSERTION: "/auth/webauthn/assertion-options",
    SIGNIN_WEBAUTHN_VERIFY: "/auth/webauthn/verify",

    // The below URL not active, since we have merged email, password in a single page.
    SIGNIN_IDENTIFY: "/saga_auth.login.user.identity_search.get_user_by_username",
    // -----------------------------------------------------------------------------------------------------------------------------------/

    // Account Recovery (ADDED)
    // Account Recovery (Advanced Flow)
    RECOVERY_IDENTIFY: "/recovery/identify/step",
    RECOVERY_METHODS: "/recovery/methods/list",
    RECOVERY_MK_INITIATE: "/recovery/initiate/start", // "MK" to avoid conflict with existing generic RECOVERY_INIT if needed, or replace. Using RECOVERY_INITIATE name from plan.
    RECOVERY_VERIFY_IDENTITY: "/recovery/verify/identity",
    RECOVERY_VERIFY_AUTHORITY: "/recovery/verify/authority",
    RECOVERY_RESET_PASSWORD: "/recovery/reset/confirm",
    // Keeping legacy for backward compat if needed, or repurposing:
    RECOVERY_INIT: "/saga_auth.account_recovery.initiate_user.password_reset",
    RECOVERY_VERIFY_TOKEN: "/saga_auth.account_recovery.token_verify.validate",
    RECOVERY_LOST_ACCESS: "/saga_auth.mfa_recovery.request.sending",
    RECOVERY_REQUEST_STATUS: "/saga_auth.mfa_recovery.recovery_status.status",
} as const;
